import { useState, useEffect } from 'react';

const navItems = [
  { label: '热门推荐', href: '#cards' },
  { label: '移动观影', href: '#app' },
  { label: '观众热评', href: '#comments' },
  { label: '热播榜单', href: '#ranking' },
  { label: '最新动态', href: '#updates' },
  { label: '平台优势', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 60);
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function handleNavClick(href: string) {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('#hero');
            }}
            className="font-heading text-2xl text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            爱豆影视
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#hero');
              }}
              className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors rounded-md whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <nav className="flex flex-col px-4 py-3 gap-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#hero');
              }}
              className="px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
            >
              首页
            </a>
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(item.href);
                }}
                className="px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-background-100 rounded-md transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}